import React, { useEffect, useState, useCallback } from 'react';

import { Item, Toolbar } from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';
import DropDownButton from 'devextreme-react/drop-down-button';

import {
  OwnerCards,
  OwnerForm,
} from '../../components';

import { Contact } from '../../types/crm-contact';

import {
  getContact,
  getContactNotes,
  getContactMessages,
  getActiveContactOpportunities,
  getClosedContactOpportunities,
} from 'dx-template-gallery-data';

import './owner.scss';
import ScrollView from 'devextreme-react/scroll-view';

const CONTACT_ID = 12;

export const Owner = () => {
  const [data, setData] = useState<Contact>();
  const [messagesCount, setMessagesCount] = useState(0);
  const [notes, setNotes] = useState();
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const onMessagesCountChanged = useCallback((count) => {
    setMessagesCount(count);
  }, []);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = useCallback(() => {
    Promise.all([
      getContact(CONTACT_ID)
        .then((data) => {
          setData(data);
        }),
      getContactNotes(CONTACT_ID)
        .then((data) => {
          setNotes(data);
        }),
      getContactMessages(CONTACT_ID)
        .then((data) => {
          setMessages(data);
          setMessagesCount(data.length);
        }),
      getActiveContactOpportunities(CONTACT_ID),
      getClosedContactOpportunities(CONTACT_ID),
    ]).then(() => { setIsLoading(false); }).catch((error) => console.log(error));
  }, []);

  const refresh = useCallback(() => {
    setIsLoading(true);
    loadData();
  }, []);

  return (
    <ScrollView className='view-wrapper-scroll'>
      <div className='view-wrapper view-wrapper-contact-details'>
        <Toolbar className='toolbar-details'>
          <Item location='before'>
            <Button icon='arrowleft' stylingMode='text' />
          </Item>
          <Item location='before' text={ data?.name ?? 'Loading...' } />
          <Item location='after'>
            <DropDownButton
              text='Actions'
              stylingMode='text'
              width={120}
              items={['Sblocca']}
            />
          </Item>
          <Item location='after' locateInMenu='auto'>
            <div className='separator' />
          </Item>
          <Item
            location='after'
            locateInMenu='auto'
            widget='dxButton'
            showText='inMenu'
          >
            <Button
              text='Refresh'
              icon='refresh'
              stylingMode='text'
              onClick={refresh}
            />
          </Item>
        </Toolbar>

        <div className='panels'>
          <div className='left'>
            <OwnerForm
              data={data}
              isLoading={isLoading}
            />
          </div>

          <div className='right'>
            <OwnerCards
              isLoading={isLoading}
              notes={notes}
              messages={messages}
              messagesCount={messagesCount}
              onMessagesCountChanged={onMessagesCountChanged}
              tasks={data?.tasks}
              name={data?.name} />
          </div>
        </div>
      </div>
    </ScrollView>
  );
};
